import { View, ActivityIndicator } from "react-native";
import { getSchemeStyle } from "../context/helper";

const ActivityScreen = () => {
  const schemeStyles = getSchemeStyle();
    return (
      <View style={[{ flex: 1, justifyContent: "center", alignItems: "center" },schemeStyles.Background]}>
        <ActivityIndicator size={"large"} />
      </View>
    );
};

export default ActivityScreen;

